<template>
  <!-- cleanned ok-->
  <div id="listeGlobal">
    
    <!-- Boutons de navigation -->
    <div id="navTop" v-if="storeJobsDatas.boutons.length > 0"> 
      <div class="logoRagency" @click="affichageParDefaut()"></div>
      <div class="flexEnLigne">
        <!-- Boutons de filtres -->
        <h2
          v-for="(item, index) in storeJobsDatas.boutons"
          :key="index"
          class="bouttons"
          :class="[
            { active: item.filtre?.toLowerCase() === filtrePar }
          ]"
          @click="handleFilterButtonClick(item)"
        >
          {{ item[langue]?.toUpperCase() }}
      </h2>

        <div class="break"></div>
       
        <!-- Bouton Ma Sélection -->
        <h2
          id="maSelection" 
          class="btSelection soloBt bouttons"
          :class="{ playlist: storeUrlArray.playlist.length > 0 }"
          @click="showPlaylist"
        >
          {{ storeJobsDatas.translations.bt_selection[langue] }} 
          <h2 class="nombre" :class="{ flash: isFlashing }" v-if="storeUrlArray.playlist.length > 0">
            {{ storeUrlArray.playlist.length }}
          </h2>
        </h2>

      </div>
    </div>

    <!-- Message d'accueil -->
    <div class="intro fade-in" v-if="filtrePar === ''"> 
      <div id="help" v-if="storeJobsDatas.translations.tutoFiltre[langue]">
        <div class="flechTop"></div>
        <div class="labulleHelp">
          <h3 v-html="storeJobsDatas.translations.tutoFiltre[langue]"></h3>
        </div>
      </div>
      <div>
        <h1 style="margin-bottom: 10px;" v-html="storeJobsDatas.config.messages.intro[langue].titre"></h1>
        <h3 style="font-size: 30px;margin-bottom: 10px; font-weight: 500;" v-html="storeJobsDatas.config.messages.intro[langue].soustitre"></h3>
        <div style="margin-bottom: 10px; font-weight: 500; color: var(--colorDark)" v-html="storeJobsDatas.config.messages.intro[langue].texte"></div>
        <p v-html="storeJobsDatas.config.messages.intro[langue].paragraphe"></p>
        <h4 v-html="storeJobsDatas.config.messages.intro[langue].linkname" class="bouttons" @click="openLink(storeJobsDatas.config.messages.intro[langue].link)"></h4>
      </div>
    </div>

    <!-- Liste double colonne -->
    <div class="zone" v-if="modeListe === 'normal' && filtrePar != ''"> 

      <!-- ////////////////////////////////////////////////////////////////////////////////////// -->
      <!-- Colonne de gauche -->
      <!-- ////////////////////////////////////////////////////////////////////////////////////// -->

      <div class="cssDouble scrollMinimal" 
           ref="scollableZoneOne" 
           @scroll="saveScrollPosition(1)">
        <div
          v-for="(item, index) in getArrayByFiltre"
          :key="index"
        >
        <div v-if="findItemViaFiltre(item)" class="ligneListe"
          :class="{ active: sousfiltrePar && item === sousfiltrePar }"
          @click="selectSousFiltre(item)"
        >
        <div style="padding: 10px;">
          <h3 v-html="formatTextContent(item)"></h3>
        </div>
      </div>

        </div>
      </div>

      <!-- Indicateur de scroll colonne 1 -->
      <div class="bottomNext bottomNext-one" v-show="showBottomNextOne">
        <img src="interface/down.svg" alt="Scroll down" width="20px"/>
      </div>

      <!-- ////////////////////////////////////////////////////////////////////////////////////// -->
      <!-- Colonne de droite -->
      <!-- ////////////////////////////////////////////////////////////////////////////////////// -->

      <div class="cssDouble colonneLogo bgFx scrollMinimal"
           ref="scollableZoneTwo"
           @scroll="saveScrollPosition(2)">
        <!-- Loader temporaire -->
        <div v-if="attenteResultats" class="message">
          <img src="interface/loader.svg" alt="Chargement..." style="width:40px; margin-bottom:10px;">
          Chargement des résultats...
        </div>
        <!-- Résultats -->
        <div
          class="ligneListe"
          :class="{active: item.uuid === uuidSelected}"
          v-for="(item, index) in filteredResultatArray"
          :key="index"
        >
          <div
            class="logo"
            v-if="affichage === 'logos' && (index === 0 || item.marque !== resultatArray[index - 1].marque) && (showAll || item.visible !== false)"
            @click="handleSelectLogoOrFiche(item)"
            style="position: relative;"
          >
          
            <!-- ✅ SIMPLE : Loader -->
            <SimpleLoader :loading="!logoLoaded[item.logo]" />
            
            <!-- ✅ SIMPLE : Image -->
             <!-- utilise ratiologo pour le dimentionnement en largeur du logo -->
            <img 
              :src="'logos/' + item.logo"
              :alt="item.logo"
              class="logo-img"
              :style="{
                opacity: logoLoaded[item.logo] ? 1 : 0,
                width: item.ratiologo ? item.ratiologo + '%' : '70%',
                maxWidth: '100%',
                height: 'auto'
              }"
              @load="logoLoaded[item.logo] = true"
            />
          </div>
          <div v-if="affichage === 'noms' && (showAll || item.visible === true)"
            @click="handleSelectLogoOrFiche(item)">
            <h3 class="titreFiche" v-html="formatTitreFiche(item.titre)"></h3>
          </div>
        </div>
      </div>

      <!-- Indicateur de scroll colonne 2 -->
      <div class="bottomNext bottomNext-two" v-show="showBottomNextTwo"> 
        <img src="interface/down.svg" alt="Scroll down" width="20px"/>
      </div>
    </div>

    <!-- Vue liste -->
    <div class="zone" v-if="modeListe === 'list' && filtrePar != ''"> 
      <div class="colonneSimple scrollMinimal" ref="scollableZoneOne" @scroll="saveScrollPosition(1)">
        <div class="sousListe">
          <!-- ✅ MODIFIÉ : Logo avec SimpleLoader -->
          <div v-if="logoSelected" style="position: relative; display: inline-block;">
            <!-- ✅ NOUVEAU : SimpleLoader pour le logo -->
            <SimpleLoader :loading="!logoLoaded[logoSelected]" />
            
            <!-- ✅ MODIFIÉ : Logo avec gestion du chargement -->
             <!-- utilise ratiologo pour le dimentionnement du logo -->
            <img 
              :src="'logos/' + logoSelected" 
              :alt="marqueSelected"
              class="logo-img"
              :style="{ opacity: logoLoaded[logoSelected] ? 1 : 0 }"
              @load="logoLoaded[logoSelected] = true"
              @error="logoLoaded[logoSelected] = true"
            />
            
          </div>
          <br>
          <div id="btRetour" @click="modeListe = 'normal'"></div>
          <br>
        </div>
       
        <!-- Les vignettes de liste sont déjà OK -->
        <div class="ligneListe" :class="{active: item.uuid === uuidSelected}" v-for="(item, index) in resultatArray" :key="index">
          <div class="listeVignette" 
            v-if="item.marque === marqueSelected"
            @click="selectFromList(item)"
            style="position: relative;"
          >
            <!-- ✅ Loader pour vignette -->
            <SimpleLoader :loading="!vignetteLoaded[item.uuid]" />
            
            <!-- ✅ Vignette -->
            <div 
              :style="{ 
                backgroundImage: vignetteLoaded[item.uuid] ? `url(diapo/${vignetteResolution}/${item.vignette})` : 'none',
                opacity: vignetteLoaded[item.uuid] ? 1 : 0
              }"
            >
              <!-- ✅ Image invisible pour détecter le chargement -->
              <img 
                :src="`diapo/${vignetteResolution}/${item.vignette}`"
                style="display: none;"
                @load="vignetteLoaded[item.uuid] = true"
                @error="vignetteLoaded[item.uuid] = true"
              />
            </div>
            
            <!-- ✅ MODIFIÉ : Afficher le texte seulement quand l'image est chargée -->
            <div v-if="vignetteLoaded[item.uuid]">
              <span style="margin: 0 0 20px 0"><b>{{ item.marque }}</b></span><br>
              <i><br>{{ item.titre }}</i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Playlist -->
    <div class="zone" v-if="modeListe === 'playlist' && filtrePar != ''"> 
      <div class="colonneSimple scrollMinimal" ref="scollableZoneOne" @scroll="saveScrollPosition(1)">
        <div class="sousListe">
          <div class="zoneShare" >
            <h1 style="margin: 20px;" v-html="storeJobsDatas.translations.bt_share[langue]"></h1>
            <h3 v-html="storeJobsDatas.translations.tutoShare[langue]"></h3>
            <div style="display: flex; margin-top: 40px; gap: 20px; width: 100%;flex-direction: row; align-items: top; justify-content: center;">
              <btActions
                  @click="switchPlaylist(uuidSelected)"
                  model="left"
                  taille="normal"
                  :label="storeJobsDatas.translations.add_to_list[langue]"
                  :picto="storeUrlArray.playlist.includes(uuidSelected) ? 'circle-check-big.svg' : 'circle-plus.svg'"
                />
                <btActions
                  @click="updateStateValue({ key: 'storeModalMessage', value: 'share' })"
                  model="left"
                  taille="normal"
                  :label="storeJobsDatas.translations.bt_share[langue].toUpperCase()"
                  picto="send.svg"
                />
              </div>
          </div>
        </div>

        <!-- ✅ MODIFIÉ : Liste des éléments de la playlist avec SimpleLoader -->
        <div class="ligneListe" :class="{active: item === uuidSelected}" v-for="(item, index) in storeUrlArray.playlist" :key="index">
          <div class="listeVignette" @click="selectFromPlaylist(item)" style="position: relative;">
            <!-- ✅ SimpleLoader pour playlist -->
            <SimpleLoader :loading="!vignetteLoaded[item]" />
            
            <!-- ✅ Vignette avec gestion du chargement -->
            <div 
              :style="{ 
                backgroundImage: vignetteLoaded[item] ? `url(diapo/${vignetteResolution}/${findVignette(item)})` : 'none',
                opacity: vignetteLoaded[item] ? 1 : 0
              }"
            >
              <!-- ✅ Image invisible pour détecter le chargement -->
              <img 
                :src="`diapo/${vignetteResolution}/${findVignette(item)}`"
                style="display: none;"
                @load="vignetteLoaded[item] = true"
                @error="vignetteLoaded[item] = true"
              />
            </div>
            
            <!-- ✅ MODIFIÉ : Afficher le texte seulement quand l'image est chargée -->
            <h3 v-if="vignetteLoaded[item]" v-html="formatMarqueTitre(item)"></h3>
          </div>
        </div>
        
        <!-- Éléments de démonstration si playlist vide -->
        <div v-if="storeUrlArray.playlist.length === 0">
          <div class="listePlaylistDemo" v-for="i in 4" :key="i"></div>
        </div>
      </div>
    </div>

    <!-- Vue totale -->
    <div class="zone" v-if="modeListe === 'all' && filtrePar != ''"> 
      <div class="scrollMinimal flexCol">
        <div :class="{active: item.uuid === uuidSelected}" v-for="(item, index) in resultatArray" :key="index" style="width: 50%;">
          <div
            @click="selectFromAll(item)"
            class="listeVignetteSmall" 
            :style="{ backgroundImage: `url(diapo/500px/${findVignette(item.uuid)})` }"
          >
          </div>
        </div>
      </div>
    </div>

    <!-- Loader d'attente des résultats -->
    <div v-if="attenteResultats" class="loaderContainer">
      <SimpleLoader />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import btActions from './elements/btActions.vue'; 


export default {
  name: 'listeGlobal',
  props: {
    langue: String,
  },
   components: {
    btActions,
  },
  data() {
    return {
      resultatArray: [],
      isFlashing: false,
      filtrePar: '',
      sousfiltrePar: '',
      affichage: '',
      marqueSelected: '',
      logoSelected: '',
      modeListe: 'intro',
      uuidSelected: '',
      scrollColonneOne: 0,
      scrollColonneTwo: 0,
      showBottomNextOne: false,
      showBottomNextTwo: false,
      scrollConfig: {
        1: {
          throttle: null,
          ref: 'scollableZoneOne',
          scrollProperty: 'scrollColonneOne',
          showBottomProperty: 'showBottomNextOne'
        },
        2: {
          throttle: null,
          ref: 'scollableZoneTwo',
          scrollProperty: 'scrollColonneTwo',
          showBottomProperty: 'showBottomNextTwo'
        }
      },
      logoLoaded: {}, // ✅ SIMPLE : État de chargement des logos
      vignetteLoaded: {} // ✅ SIMPLE : État de chargement des vignettes
    };
  },
  
  mounted() {
    const checkDataReady = setInterval(() => {
      if (this.storeJobsDatas.jobs.length > 0) {
        clearInterval(checkDataReady);
        this.updateResults();
        this.configureScreenFromUrl();
      }
    }, 100); 
    
    const checkDataReadyToScreen = setInterval(() => {
      if (this.storeUrlArray.sousfiltreType !== null) {
        this.init();
        clearInterval(checkDataReadyToScreen);
        this.updateResults();
      }
    }, 100); 
  },
  
  beforeUnmount() {
    Object.values(this.scrollConfig).forEach(config => {
      if (config.throttle) {
        clearTimeout(config.throttle);
      }
    });
  },
  
  computed: {
    ...mapState(['storeJobsDatas', 'storeUrlArray', 'storeEcran', 'storeMode', 'triggerModeList','modeAdmin', 'showAll']),
    ...mapGetters(['getIndexIdByUuid', 'getInfosByUuid']),

    getArrayByFiltre() {
      if (!this.filtrePar) return [];
      
      const data = this.storeJobsDatas.filtres?.[this.langue]?.[this.filtrePar];
      if (!Array.isArray(data)) return [];
      
      return data.filter(item => item !== '*').sort((a, b) => a.localeCompare(b, this.langue));
    },
    filteredResultatArray() {
      // Si aucun sous-filtre, on affiche tout
      if (!this.sousfiltrePar) {
        return this.resultatArray;
      }
      // Sinon, on filtre selon le sous-filtre sélectionné
      return this.resultatArray.filter(item =>
        item.marque === this.sousfiltrePar ||
        (Array.isArray(item.secteurs) && item.secteurs.includes(this.sousfiltrePar)) ||
        (typeof item.secteurs === 'string' && item.secteurs.includes(this.sousfiltrePar)) ||
        (Array.isArray(item.types) && item.types.includes(this.sousfiltrePar)) ||
        (typeof item.types === 'string' && item.types.includes(this.sousfiltrePar)) ||
        (Array.isArray(item.expertises) && item.expertises.includes(this.sousfiltrePar)) ||
        (typeof item.expertises === 'string' && item.expertises.includes(this.sousfiltrePar))
      );
    },
    vignetteResolution() {
      // Utilise une détection simple (peut être améliorée)
      return window.innerWidth < 780 ? '200px' : '500px';
    },
    attenteResultats() {
      // Affiche le loader si on a un filtre actif, que la colonne de droite est vide,
      // mais que resultatArray n'est pas vide (donc il y a potentiellement des résultats à venir)
      return this.filtrePar && this.resultatArray.length > 0 && this.filteredResultatArray.length === 0;
    },
  },
  
  methods: {
    ...mapActions(['updateStateValue', 'updateStoreUrl', 'setHideFiche', 'switchPlaylist']),

    // Initialisation du scroll à partir du store
    initScrollPositions() {
      this.scrollColonneOne = Number(this.storeUrlArray.storeScrollColonneOne) || 0;
      this.scrollColonneTwo = Number(this.storeUrlArray.storeScrollColonneTwo) || 0;
      this.$nextTick(() => {
        this.scrollTo('scollableZoneOne', this.scrollColonneOne);
        this.scrollTo('scollableZoneTwo', this.scrollColonneTwo);
        this.initBottomNextStates();
      });
    },

    // Sauvegarde la position de scroll dans le store à chaque scroll
    saveScrollPosition(columnNumber) {
      const config = this.scrollConfig[columnNumber];
      if (!config || config.throttle) return;

      config.throttle = setTimeout(() => {
        const element = this.$refs[config.ref];
        if (element) {
          this[config.scrollProperty] = element.scrollTop;
          // Synchronise dans le store
          if (columnNumber === 1) {
            this.updateStoreUrl({ tag: 'storeScrollColonneOne', value: element.scrollTop });
          } else if (columnNumber === 2) {
            this.updateStoreUrl({ tag: 'storeScrollColonneTwo', value: element.scrollTop });
          }

          const { scrollTop, scrollHeight, clientHeight } = element;
          const threshold = 20;
          const hasScrollableContent = scrollHeight > clientHeight + threshold;
          const isAtBottom = Math.abs(scrollTop + clientHeight - scrollHeight) <= threshold;
          this[config.showBottomProperty] = hasScrollableContent && !isAtBottom;
        }
        config.throttle = null;
      }, 16);
    },

    // Utilitaire pour scroller à une position donnée
    scrollTo(target, y) {
      const el = this.$refs[target];
      if (el) {
        el.scrollTo({ top: y, behavior: 'auto' });
      }
    },

    // Réinitialise le scroll à la position mémorisée dans le store (jamais à zéro sauf action explicite)
    resetScrollPositions() {
      this.scrollColonneOne = Number(this.storeUrlArray.storeScrollColonneOne) || 0;
      this.scrollColonneTwo = Number(this.storeUrlArray.storeScrollColonneTwo) || 0;
      this.$nextTick(() => {
        this.scrollTo('scollableZoneOne', this.scrollColonneOne);
        this.scrollTo('scollableZoneTwo', this.scrollColonneTwo);
        this.showBottomNextOne = false;
        this.showBottomNextTwo = false;
        setTimeout(() => {
          this.initBottomNextStates();
        }, 150);
      });
    },

    init() {
      this.filtrePar = this.storeUrlArray.filtreType;
      this.sousfiltrePar = this.storeUrlArray.sousfiltreType;
      this.modeListe = this.storeUrlArray.mode;
      this.uuidSelected = this.storeUrlArray.uuid;
      this.marqueSelected = this.storeUrlArray.marque || '';
      this.logoSelected = this.storeUrlArray.logo || '';

      setTimeout(() => {
        this.initScrollPositions();
      }, 100);
    },

    affichageParDefaut() {
      this.updateStoreUrl({ tag: 'uuid', value: 'rag0' });
      this.filtrePar = '';
    },

    findVignette(uuid) {
      return this.getInfosByUuid(uuid, this.langue, 'vignette');
    },
    
    findInfo(uuid) {
      return this.getInfosByUuid(uuid, this.langue, 'infos');
    },
    
    initBottomNextStates() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.updateAllBottomNextStates();
        }, 100);
      });
    },
    
    updateAllBottomNextStates() {
      Object.keys(this.scrollConfig).forEach(columnNumber => {
        const config = this.scrollConfig[columnNumber];
        const element = this.$refs[config.ref];
        if (element) {
          const { scrollTop, scrollHeight, clientHeight } = element;
          const threshold = 20;
          
          const hasScrollableContent = scrollHeight > clientHeight + threshold;
          const isAtBottom = scrollTop + clientHeight >= scrollHeight - threshold;
          
          this[config.showBottomProperty] = hasScrollableContent && !isAtBottom;
        }
      });
    },
    
    findItemViaFiltre(target) {
      // si filtrePar = 'secteurs'
      //
      //console.log('findItemViaFiltre:', this.filtrePar,target);
      if(this.filtrePar === 'marques' && this.showAll === false) {
        return !!this.storeJobsDatas.jobs.find(
          item => item.marque === target && item.visible === true
        );
      }else{
        return true;
      }
    },
    
    formatMarqueTitre(uuid) {
      const infos = this.getInfosByUuid(uuid, this.langue, 'infos');
      return `<span style="margin: 0 0 20px 0"><b>${infos[0]}</b></span><br><i><br>${infos[1]}</i>`;
    },

    // Méthodes de sélection simplifiées
    selectSousFiltre(item) {
      if (item === this.sousfiltrePar) {
        this.sousfiltrePar = '';
        this.updateStoreUrl({ tag: 'storeScrollColonneOne', value: this.scrollColonneOne });
        return;
      }
      this.sousfiltrePar = item;
      this.updateStoreUrl({ tag: 'storeScrollColonneOne', value: this.scrollColonneOne });
    },

    selectFromList(item) {
      this.handleSelectLogoOrFiche(item);
      this.updateStoreUrl({ tag: 'storeScrollColonneOne', value: this.scrollColonneOne });
    },

    selectFromPlaylist(item) {
      this.openFiche(item);
      this.updateStoreUrl({ tag: 'storeScrollColonneOne', value: this.scrollColonneOne });
    },

    selectFromAll(item) {
      this.filtrePar = 'all';
      this.affichage = 'vignettes';
      this.sousfiltrePar = '';
      this.handleSelectLogoOrFiche(item);
      this.updateStoreUrl({ tag: 'storeScrollColonneOne', value: this.scrollColonneOne });
    },

    handleSelectLogoOrFiche(item) {
      // Gestion sélection logo/marque si besoin
      if (item.logo) {
        this.marqueSelected = item.marque;
        this.logoSelected = item.logo;
        this.updateStoreUrl({ tag: 'storeScrollColonneTwo', value: this.scrollColonneTwo });
      }

      // Gestion ouverture fiche
      this.setHideFiche(false);

      if (this.modeListe === 'list' || this.modeListe === 'all') {
        this.openFiche(item.uuid);
      } else if (this.affichage === 'logos' && this.countLogoOccurrences(item.logo) > 1) {
        this.modeListe = 'list';
      } else {
        this.openFiche(item.uuid);
      }
    },
    
    openFiche(uuid) {
      // sur mobile si on reclick sur le même uuid la fiche s'ouvre
      this.updateStateValue({ key: 'ficheOn', value: true });

      console.log('openFiche:', uuid);
      this.uuidSelected = uuid;
      this.updateStoreUrl({ tag: 'uuid', value: uuid });
    },
    
    countLogoOccurrences(logo) {
      if (!logo) return 0;
      return this.resultatArray.filter(item => item.logo === logo).length;
    },

    // Génération des résultats //////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

   generateResults(mode) {
    let jobs = this.storeJobsDatas.jobs;

    // Filtrage selon le mode
    if (mode === 'marques') {
      jobs = jobs.filter(item => {
        const val = item.marque;
        return Array.isArray(val)
          ? val.includes(this.sousfiltrePar)
          : typeof val === 'string'
            ? val.includes(this.sousfiltrePar)
            : false;
      });
    } else if (mode === 'logos' && this.filtrePar && this.sousfiltrePar) {
      jobs = jobs.filter(item => {
        const val = item[this.langue]?.[this.filtrePar];
        return Array.isArray(val)
          ? val.includes(this.sousfiltrePar)
          : typeof val === 'string'
            ? val.includes(this.sousfiltrePar)
            : false;
      });
    }
    // mode === 'total' => pas de filtre

    // Mapping commun
    this.resultatArray = jobs.map(item => ({
      uuid: item.uuid || '',
      visible: item.visible || '',
      marque: typeof item.marque === 'string'
    ? item.marque
    : Array.isArray(item.marque)
      ? item.marque.join(', ')
      : '',
      secteurs: item[this.langue]?.secteurs || '',
      types: item[this.langue]?.types || '',
      expertises: item[this.langue]?.expertises || '',
      logo: item.logo || '',
      ratiologo: item.ratiologo || '',
      titre: item[this.langue]?.titre || '',
      vignette: this.findVignette(item.uuid) || '',
      note: item.note || 0,
      tags: item[this.langue]?.tags || '',
      auteurs: item.auteurs || '',
    }));

    // Tri si besoin
    if (mode === 'total') {
      this.resultatArray.sort((a, b) => a.marque.localeCompare(b.marque, this.langue));
      this.modeListe = 'all';
    } else if (mode === 'logos') {
      this.sortResultsByBrandAndRating();
    }

    this.initBottomNextStates();
},
    
    clearResults() {
      this.resultatArray = [];
      this.showBottomNextOne = false;
      this.showBottomNextTwo = false;
      //
    },
    
    updateResults() {
      if (this.affichage === 'logos') {
        this.generateResults('logos');
      } else if (this.affichage === 'noms') {
        this.generateResults('marques');
      } else if (this.affichage === 'all') {
        this.generateResults('total');
      }
    },
    
    sortResultsByBrandAndRating() {
      this.resultatArray.sort((a, b) => {
        if (a.marque !== b.marque) {
          return a.marque.localeCompare(b.marque, this.langue);
        }
        return (b.note || 0) - (a.note || 0);
      });
    },

    formatTextContent(value) {
      return value.replace(/ \/ /g, '<br>');
    },

    configureScreenFromUrl() {
      // Configuration à partir de l'URL si nécessaire
    },

    triggerFlash() {
      this.isFlashing = false;
      // Force le DOM à appliquer la suppression de la classe avant de la remettre
      setTimeout(() => {
        this.isFlashing = true;
        setTimeout(() => {
          this.isFlashing = false;
        }, 800); // même durée que l'animation CSS
      }, 10); // 10ms suffisent pour forcer le repaint
    },
    
    openLink(url) {
      window.open(url, '_blank');
    },

    activemodeListe() {
      if (this.filtrePar !== 'all') {
        this.generateResults('total');
        this.filtrePar = 'all';
        this.sousfiltrePar = '';
        this.scrollColonneOne = 0;
        this.scrollColonneTwo = 0;
      } else {
        this.affichageParDefaut();
      }
    },
    
    handleFilterButtonClick(item) {
      const filtre = item.filtre?.toLowerCase();
      if (filtre === this.filtrePar) {
        this.filtrePar = '';
        this.sousfiltrePar = undefined;
        this.modeListe = 'intro';
        this.marqueSelected = '';
        this.logoSelected = '';
        this.clearResults();
        return;
      }
      this.filtrePar = filtre;
      this.sousfiltrePar = undefined;
      this.modeListe = 'normal';
      this.marqueSelected = '';
      this.logoSelected = '';

      if (item.affiche === 'all') {
        this.generateResults('total');
      } else {
        this.clearResults();
      }

      // Ajout : sauvegarde l'action dans la base
      this.$store.dispatch('saveActionToMemo', {
        action: 'listeGlobal',
        tag: 'filtreType',
        value: filtre
      });
    },
    
    showPlaylist() {
      this.modeListe = 'playlist';
      this.filtrePar = 'playlist';
      this.sousfiltrePar = '';
    },
    
    addToPlaylist() {
      this.triggerFlash();
    },

    formatTitreFiche(titre) {
      if (!titre) return '';
      // Remplace tous les « et » par "
      // “ 
      // Remplace les guillemets français et anglais par "
      titre = titre.replace(/[“”«»]/g, '"');
      // Si on trouve 2 guillemets, on remplace le premier par <br>" et le deuxième par "
      const quoteMatches = titre.match(/"/g);
      if (quoteMatches && quoteMatches.length === 2) {
        let first = titre.indexOf('"');
        let second = titre.indexOf('"', first + 1);
        return (
          titre.slice(0, first) +
          '<br><b>«' +
          titre.slice(first + 1, second) +
          '»</b>' +
          titre.slice(second + 1)
        );
      }
      // Sinon, première lettre en majuscule, le reste en minuscules
      return titre.charAt(0).toUpperCase() + titre.slice(1).toLowerCase();
    },
  },

  watch: {
    langue() {
      this.updateResults();
    },
    
    filtrePar() {
      this.updateStoreUrl({ tag: 'filtreType', value: this.filtrePar });
      this.resetScrollPositions();

      const bouton = this.storeJobsDatas.boutons.find(
        item => (item.filtre?.toLowerCase() === this.filtrePar)
      );
      this.affichage = bouton ? bouton.affiche : "";

      // Ajoute ceci :
      this.$nextTick(() => {
        this.updateResults();
      });
    },
    sousfiltrePar() {
      this.updateStoreUrl({ tag: 'sousfiltreType', value: this.sousfiltrePar });
      this.scrollColonneTwo = 0;
      this.$nextTick(() => {
        this.scrollTo('scollableZoneTwo', 0);
        this.showBottomNextTwo = false;
        setTimeout(() => {
          this.updateAllBottomNextStates();
        }, 100);
        // Ajoute ici aussi :
        if (this.sousfiltrePar !== '') {
          this.updateResults();
        }
        
      });
    },
    
    marqueSelected() {
      this.updateStoreUrl({ tag: 'marque', value: this.marqueSelected });
    },
    
    affichage() {
      this.updateStoreUrl({ tag: 'affichage', value: this.affichage });
    },
    
    modeListe() {
      this.updateStoreUrl({ tag: 'mode', value: this.modeListe });
      this.resetScrollPositions();
    },
    
    logoSelected() {
      this.updateStoreUrl({ tag: 'logo', value: this.logoSelected });
    },
    
    'storeUrlArray.uuid'() {
      this.uuidSelected = this.storeUrlArray.uuid;
    },
    
    
    triggerModeList(newVal) {
      if (newVal) {
        this.activemodeListe();
      }
    }
  },
};
</script>

<style>
/* === VARIABLES === */
:root {
  --zoneFiltre: 100px;
}

/* === STRUCTURE PRINCIPALE === */
#listeGlobal {
  color: var(--colorLight);
  height: var(--hauteur);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* === NAVIGATION === */
#navTop {
  display: flex;
  flex-shrink: 0;
  min-height: 60px;
}

.logoRagency {
  width: 60px !important;
  min-width: 60px;
  max-width: 60px;
  height: 60px;
  min-height: 60px;
  max-height: 60px;
  background-image: url('/public/logos/R.svg');
  background-position: 16px 10px;
  background-size: 30px auto;
  background-repeat: no-repeat;
  box-sizing: border-box;
  flex: 0 0 60px;
}

.flexEnLigne {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  padding: 10px 0 6px 0;
  flex: 1;
}

.flexEnLigne > * {
  margin: 0;
  border-radius: 0;
}

/* === ZONES PRINCIPALES === */
.zone {
  flex: 1;
  display: flex;
  flex-flow: row wrap;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  min-height: 0;
}

.intro {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  min-height: 0;
  background-color: var(--colorActive);
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
}
.intro h1, .intro h2 {
  color: var(--colorDark);
}

@keyframes help-blink {
  0%   { opacity: 0; }
  10%  { opacity: 1; }
  70%  { opacity: 1; }
  100% { opacity: 0; }
}

#help {
  animation: help-blink 2.5s linear 2.5;
  animation-fill-mode: forwards;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 10px;
  left: 0;
  right: 0;
  z-index: 10;
  opacity: 1;
}

#help .flechTop {
  background-color: var(--colorLight);
  width: 30px;
  height: 30px;
  rotate: 45deg;
  z-index: 11;
}
#help .labulleHelp {
  text-align: center;
  background-color: var(--colorLight);
  color: var(--colorDark);
  padding: 10px 20px;
  margin: -20px 20px 20px 20px; /* ← ici */
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  font-size: 15px;
  font-weight: 500;
  z-index: 12;
  position: relative;
}

/* === COLONNES === */
.cssDouble {
  width: 50%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.colonneSimple {
  width: 100%;
  height: 100%;
  color: var(--colorWhite);
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
}

.scrollMinimal {
  height: 100%;
  overflow-y: auto;
}

.flexCol {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  overflow-y: auto;
}

/* === BOUTONS === */


.bouttons.flashing {
  animation: flash 1s ease-in-out;
}

.nombre.flash {
  animation: flash 0.8s;
}

@keyframes flash {
  0%   { background-color: var(--colorLight); }
  50%  { background-color: var(--colorActive); }
  100% { background-color: var(--colorLight); }
}

.bouttons .nombre {
  color: var(--colorWhite);
  text-align: center;
  padding: 5px 10px;
  border-radius: 20px;
  aspect-ratio: 1/1;
  margin-left: 5px;
}

.btSelection {
  background-color: var(--colorLight);
}


/* === ÉLÉMENTS DE CONTENU === */
.ligneListe {
  width: 100%;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.2;
  color: var(--colorLight);
}

.ligneListe:hover  {
  background-color: white !important;
  color: var(--colorDark) ;
}

.ligneListe.active  {
  background-color: var(--colorVeryLight);
  color: var(--colorDark) ;
}

.ligneListe img {
  filter: invert(1);
}

.titreFiche {
  padding: 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
}
.titreFiche b {
  font-weight: 300;
}

/* === LOGOS === */
.logo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  cursor: pointer;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  aspect-ratio: 4 / 1;
  text-align: center;
}

.logo-img {
  height: auto;
  object-fit: contain;
}

.logo img {
  max-width: 100px;
  max-height: 100px;
}

.colonneLogo .ligneListe:hover img, 
.ligneListe.active img {
  filter: invert(0);
}

.ligneListe.active .logo img, 
.logo:hover img {
  margin: 0;
  opacity: 1;
}

/* === LISTES === */
.sousListe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  text-align: center;
  color: var(--colorDark);
  background-color: white;
  padding: 0px 0;
  flex-shrink: 0;
}



.sousListe img {
  max-width: 100px;
  max-height: 100px;
}

/* === VIGNETTES === */
.listeVignette {
  aspect-ratio: 2/1;
  display: flex;
  cursor: pointer;
}

.listeVignette :nth-child(1) {
  width: 50%;
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  transition: all 0.3s;
}

.listeVignette:hover :nth-child(1) {
  background-size: 110% auto;
}

.listeVignette :nth-child(2) {
  display: block;
  padding: 15px 0px 15px 20px;
  width: calc(50% - 40px);
}

.listeVignette :nth-child(2) i {
  display: block;
  line-height: 1.1;
}

.listeVignetteSmall {
  aspect-ratio: 1/1;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  transition: all 0.3s;
}

.listeVignetteSmall:hover {
  background-size: 110% auto;
}

/* === PLAYLISTS === */
.listePlaylist {
  display: flex;
  transition: all 0.3s;
  aspect-ratio: 1/1;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  margin: 20px;
}

.listePlaylist:hover {
  background-size: 110% auto;
}

.listePlaylistDemo {
  display: flex;
  transition: all 0.3s;
  aspect-ratio: 2/1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  margin: 10px;
  justify-content: center;
  align-items: center;
  border: 2px dotted var(--colorLight);
  color: var(--colorLight);
  opacity: 0.5;
}

.playlist {
  padding-right: 0 !important;
}

/* === BOUTONS DE NAVIGATION === */
#btRetour {
  width: 30px;
  height: 30px;
  background-size: contain;
  cursor: pointer;
  background-image: url('/public/interface/back.svg');
}

.zoneShare{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 20px;
}

.btShare {
  color: var(--colorLight);
  text-align: center;
  background-image: url('/public/interface/send.svg');
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: 30px 30px;
  transition: all 0.3s;
  font-size: 12px;
}

.btShare:hover {
  background-position: top center;
}

/* === BOTTOM NEXT === */
.bottomNext {
  position: absolute;
  bottom: 0;
  width: 50%;
  height: 30%;
  background: linear-gradient(180deg, rgba(var(--colorVeryDark-rgb), 0) 0%, rgba(var(--colorVeryDark-rgb), 1) 90%);
  color: var(--colorLight);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 10px;
  z-index: 100;
  pointer-events: none;
  font-size: 11px;
  font-weight: 300;
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.bottomNext-one {
  left: 0;
}

.bottomNext-two {
  right: 0;
}

/* === MESSAGES === */
.message {
  color: var(--colorLight);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  padding: 40px 30px 0 20px;
  text-align: center;
}

/* === SCROLLBAR === */
.scrollMinimal::-webkit-scrollbar {
  width: 5px;
}

.scrollMinimal::-webkit-scrollbar-track {
  background-color: var(--scrollBarActive);
}

.scrollMinimal::-webkit-scrollbar-thumb {
  background-color: var(--scrollBar);
  border-radius: 0;
}

/* === TYPOGRAPHIE === */
h4 {
  margin: 0;
}

i {
  font-size: 12px;
}

/* === UTILITAIRES === */
.break {
  flex-basis: 100%;
  height: 0;
}

/* === RESPONSIVE === */
@media screen and (max-width: 780px) {
  .bottomNext {
    font-size: 10px;
    width: 50%;
  }
  
  .bottomNext-one {
    left: 0;
    width: 50%;
  }
  
  .bottomNext-two {
    right: 0;
    width: 50%;
  }
  
  .cssDouble .scrollMinimal {
    padding-bottom: 50px !important;
  }
}
</style>
